module.exports = __webpack_public_path__ + "static/media/u-hero-small.d113713c.png";